/* eslint-disable react-hooks/exhaustive-deps */
import { useHistory } from 'react-router-dom';
import { Logo, Option, Section } from './_header';

import Login from '../../assets/img/Login.svg';

export const Header = () => {
  const history = useHistory();

  return (
    <Section>
      <Logo onClick={() => history.push('/')} />
      <Option
        src={Login}
        alt="Icon Login"
        active={false}
        onClick={() => history.push('/login')}
      />
    </Section>
  );
};
